export const QUERY_EXECUTION_RES_RETRY_COUNT = 150;
export const RETRIABLE_STATUSES = {
  504: true,
  404: true
};
